import { inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/abstract-classes/api.service/api.service';
import { GemstoneShape } from 'src/app/interfaces/gemstone-shape';
import { StoneShapesProviderService } from 'src/app/providers/stone-shapes/stone-shapes.provider.service';

@Injectable({
  providedIn: 'root'
})
export class StoneShapesService extends ApiService<GemstoneShape, StoneShapesProviderService> {
  private providerService = inject(StoneShapesProviderService);
  protected override get provider(): StoneShapesProviderService {
    return this.providerService;
  }
}
